import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, MapPin, Mail, Phone, Heart } from 'lucide-react';
import { socialLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-rush-navy text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-rush-pink/20 rounded-full blur-2xl" />
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-rush-mint/20 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-5xl font-display text-white mb-4">rush!</h2>
            <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-md">
              Premium frozen yogurt with fresh fruit toppings. Bringing moments of joy across Nigeria, Ghana, and Lithuania. 🍦🍓🍒
            </p>
            <div className="flex items-center space-x-4">
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-rush-pink flex items-center justify-center hover:scale-110 transition-transform"
              >
                <Instagram size={20} />
              </a>
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-rush-blue flex items-center justify-center hover:scale-110 transition-transform"
              >
                <Facebook size={20} />
              </a>
              <a
                href={socialLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-rush-mint flex items-center justify-center hover:scale-110 transition-transform text-rush-navy"
              >
                <Twitter size={20} />
              </a>
              <span className="text-rush-pink font-bold ml-2">{socialLinks.handle}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-rush-mint">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block transition-transform">
                  → Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block transition-transform">
                  → About Us
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-white/70 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block transition-transform">
                  → Locations
                </Link>
              </li>
              <li>
                <Link to="/franchise" className="text-white/70 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block transition-transform">
                  → Franchise
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-6 text-rush-mint">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-rush-pink mt-0.5" />
                <span className="text-white/70 text-sm">hello@rushfroyo.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-rush-pink mt-0.5" />
                <span className="text-white/70 text-sm">+234 801 234 5678</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-rush-pink mt-0.5" />
                <span className="text-white/70 text-sm">Nigeria • Ghana • Lithuania</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} RUSH Frozen Yogurt. All rights reserved.
            </p>
            <p className="text-white/50 text-sm mt-2 md:mt-0 flex items-center">
              Made with <Heart size={14} className="mx-1 text-rush-pink fill-rush-pink" /> for frozen yogurt lovers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
